import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import * as styles from './index.module.scss';

import RichText from '../../lib/contentful/rich-text';

const ImageText = ({
    text,
    image,
    flipBlock
  }) => {

  return (
    <div
      className={`${styles.imageTextWrapper} ${flipBlock && styles.flip}`}
    >
        { text &&
            <div
                className={styles.half}
            >
                {RichText(text)}
            </div>
        }
      { image &&
        <GatsbyImage 
          alt={image?.title}
          className={`${styles.half} ${styles.image}`}
          image={getImage(image)} 
        />
      }
    </div>
  );
}

export default ImageText;